document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("p[data-content]").forEach(p => {
        if (p.innerHTML.trim() !== "") return; // ⬅️ Skip if element already has content

        const raw = p.getAttribute("data-content");

        // Decode escaped HTML (turn &lt;br&gt; etc. into <br>)
        const textarea = document.createElement("textarea");
        textarea.innerHTML = raw;
        const decoded = textarea.value;

        // Extract content up to the first double line break (<br><br> or variants)
        const parts = decoded.split(/<br\s*\/?>\s*<br\s*\/?>/i);
        const firstParagraph = parts[0] || decoded;

        // Render that paragraph only
        p.innerHTML = firstParagraph.trim();
    });
});
